// extracted by mini-css-extract-plugin
export default {"basic-number-input":"BasicNumberInput_basic-number-input__Oc89G","input-label":"BasicNumberInput_input-label__7OA9B","error":"BasicNumberInput_error__NZG7b"};